import { render, staticRenderFns } from "./TableForm.vue?vue&type=template&id=4f6b7f9a"
import script from "./TableForm.vue?vue&type=script&lang=ts"
export * from "./TableForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports